import React, { FC, useEffect } from 'react';

import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';

import { REPORT_TYPES, report } from '@adsk/exo-skeleton-api';
import {
  safeStringify,
  wrapWithEventPropertiesPrefix,
} from '@adsk/exo-skeleton-api/internal';

import { EXO_SKELETON_SCOPE_NAME } from '../../consts';
import { REPORT_EVENT_TYPES } from '../../utils/monitoring';

type RedirectProps = {
  from: string;
  to: string;
};

const Redirect: FC<RedirectProps> = ({ from, to }) => {
  useEffect(() => {
    if (from) {
      const unsafeGlobalContext = {
        from,
        to,
        type: REPORT_EVENT_TYPES.DEPRECATED_ROUTE_OR_REDIRECT,
      };

      const error = new Error(`Access to deprecated route detected: ${from}`);
      void report({
        scope: EXO_SKELETON_SCOPE_NAME,
        type: REPORT_TYPES.warning,
        value: error,
        context: {
          ...wrapWithEventPropertiesPrefix({
            data: safeStringify(unsafeGlobalContext),
            type: REPORT_TYPES.warning,
            stack: error.stack,
            message: error.message,
          }),
        },
        UNSAFE__globalContext: unsafeGlobalContext,
      });
    }
  }, [from, to]);

  return <Navigate to={to} replace />;
};

Redirect.propTypes = {
  /** path to redirect from */
  from: PropTypes.string.isRequired,
  /** path to redirect to */
  to: PropTypes.string.isRequired,
};

export default Redirect;
